"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemStore = void 0;
const lodash_1 = require("lodash");
const BFParameters_1 = require("./BFParameters");
function isReferencedValue(val) {
    return val.startsWith(BFParameters_1.REF);
}
class MemStore {
    constructor() {
        this.variableStore = {};
    }
    setVariable(bfId, key, value) {
        this.variableStore[bfId] = this.variableStore[bfId] || {};
        this.variableStore[bfId][key] = value;
    }
    getVariable(bfId, key) {
        if (!this.variableStore[bfId]) {
            return undefined;
        }
        return this.variableStore[bfId][key];
    }
    getFromRefVal(ref) {
        if (isReferencedValue(`${ref}`)) {
            const refVal = lodash_1.trimStart(ref, BFParameters_1.REF);
            return lodash_1.get(this.variableStore, refVal);
        }
        return ref;
    }
    reset() {
        this.variableStore = {};
    }
}
exports.MemStore = MemStore;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVtU3RvcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL01lbVN0b3JlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUF3QztBQUV4QyxpREFBcUM7QUFFckMsU0FBUyxpQkFBaUIsQ0FBQyxHQUFXO0lBQ3BDLE9BQU8sR0FBRyxDQUFDLFVBQVUsQ0FBQyxrQkFBRyxDQUFDLENBQUM7QUFDN0IsQ0FBQztBQUVELE1BQWEsUUFBUTtJQU1uQjtRQUxBLGtCQUFhLEdBSVQsRUFBRSxDQUFDO0lBQ1EsQ0FBQztJQUNoQixXQUFXLENBQUMsSUFBWSxFQUFFLEdBQVcsRUFBRSxLQUFVO1FBQy9DLElBQUksQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLEdBQUcsSUFBSSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLENBQUM7UUFDMUQsSUFBSSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsQ0FBQyxHQUFHLENBQUMsR0FBRyxLQUFLLENBQUM7SUFDeEMsQ0FBQztJQUNELFdBQVcsQ0FBQyxJQUFZLEVBQUUsR0FBVztRQUNuQyxJQUFJLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsRUFBRTtZQUM3QixPQUFPLFNBQVMsQ0FBQztTQUNsQjtRQUNELE9BQU8sSUFBSSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUN2QyxDQUFDO0lBQ0QsYUFBYSxDQUFDLEdBQVE7UUFDcEIsSUFBSSxpQkFBaUIsQ0FBQyxHQUFHLEdBQUcsRUFBRSxDQUFDLEVBQUU7WUFDL0IsTUFBTSxNQUFNLEdBQUcsa0JBQVMsQ0FBQyxHQUFHLEVBQUUsa0JBQUcsQ0FBQyxDQUFDO1lBQ25DLE9BQU8sWUFBRyxDQUFDLElBQUksQ0FBQyxhQUFhLEVBQUUsTUFBTSxDQUFDLENBQUM7U0FDeEM7UUFDRCxPQUFPLEdBQUcsQ0FBQztJQUNiLENBQUM7SUFDRCxLQUFLO1FBQ0gsSUFBSSxDQUFDLGFBQWEsR0FBRyxFQUFFLENBQUM7SUFDMUIsQ0FBQztDQUNGO0FBM0JELDRCQTJCQyJ9